/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/RequestTypesTableQuery$parameters.ts';
import type { RequestTypesTableEntrypointComponentProps } from './RequestTypesTable.entrypoint.types.tsx';
import type { RequestTypesTableQuery } from './__generated__/RequestTypesTableQuery.graphql.ts';

type EntryPointProps = {
	projectKey: string;
	cloudId: string;
};

type NestedEntrypoints = {};
type ExtraProps = {};

type Queries = {
	tableSettings: RequestTypesTableQuery;
};

type RequestTypeTableEntrypointComponent = EntryPointComponent<
	Queries,
	NestedEntrypoints,
	RequestTypesTableEntrypointComponentProps,
	ExtraProps
>;

export const requestTypeTableEntrypoint: EntryPoint<
	RequestTypeTableEntrypointComponent,
	EntryPointProps
> = createEntryPoint({
	root: JSResourceForUserVisible<RequestTypeTableEntrypointComponent>(
		/* webpackChunkName: "async-request-types-table-view-settings-panel" */ './RequestTypesTable.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ projectKey, cloudId }: EntryPointProps) => {
		return {
			queries: {
				tableSettings: {
					variables: {
						cloudId,
						projectKey,
					},
					parameters,
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
